import { render, staticRenderFns } from "./PmtaSpeeds.vue?vue&type=template&id=7a2ae15d&scoped=true"
import script from "./PmtaSpeeds.vue?vue&type=script&lang=js"
export * from "./PmtaSpeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2ae15d",
  null
  
)

export default component.exports